import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Callback } from 'Src/types/utilTypes'
import { ConsentType, RecreateLeadModel } from 'Pages/user'

export namespace UserLeadNS {
	export type RecreateLead = PayloadAction<{
		data: RecreateLeadModel
		formName?: string
		callback?: Callback
		errorCallback?: Callback
	}>

	export type UpdateUserLeadType = PayloadAction<{
		id: string
		data: {
			lead_type: ConsentType
		}
		callback?: Callback
	}>
}

export const userLeadSlice = createSlice({
	name: 'userLead',
	initialState: {},
	reducers: {
		recreateLead: (state, action: UserLeadNS.RecreateLead) => {},
		updateUserLeadType: (state, action: UserLeadNS.UpdateUserLeadType) => {},
	},
})
